const filterText = () => {
  function load_with_ajax(context) {
    var action = $(context).attr('action')

    var searchParams = $(context)
      .find(':input')
      .filter(function () {
        return $.trim(this.value).length > 0
      })
      .serialize()

    var ajaxUrl = searchParams
      ? action + '?' + searchParams + '&ajax=true'
      : action + '?ajax=true'
    var historyUrl = searchParams ? action + '?' + searchParams : action

    $('#ajax-container').animate(
      {
        opacity: 0,
      },
      100,
    )

    $.ajax({
      url: ajaxUrl,
      cache: true,
    }).done(function (data) {
      var items = $(data)

      $('#ajax-container').html(items)
      $('#ajax-container').animate(
        {
          opacity: 1,
        },
        100,
      )

      history.pushState(historyUrl, '', historyUrl)

      dataLayer.push({
        event: 'search',
        searchurl: historyUrl,
      })
    })
  }

  $('form.use-ajax :input')
    .not('input[type="text"]')
    .change(function () {
      var targetForm = $(this).closest('form.use-ajax')

      load_with_ajax(targetForm)

      return false
    })

  var typingTimer
  var typingTimeout = 700

  $('form.use-ajax input[type="text"]').on('keydown', function (e) {
    var targetForm = $(this).closest('form.use-ajax')
    var keyCode = e.keyCode || e.which

    if (keyCode === 13) {
      e.preventDefault()
      return false
    }

    clearTimeout(typingTimer)

    typingTimer = setTimeout(function () {
      console.log('now')
      load_with_ajax(targetForm)
    }, typingTimeout)
  })
}

export default filterText
